// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-confirm-rmve-offer,.btn-confirm-rmve-offer:hover{background-color:#ef4444}.confirm-remove-offer{min-width:600px}.confirm-remove-offer .el-input-group__prepend{color:#000}.confirm-remove-offer .el-input__inner{color:#000;-webkit-text-fill-color:#000!important}", ""]);
// Exports
module.exports = exports;
